import { NavigationActions, NavigationActionTypes } from '../actions/navigation.actions';
import { NavigationNode } from '../../models'

export interface State {
  nodes: NavigationNode[];
}

export const initialState: State = {
  nodes: []
};

export function reducer(state = initialState, action: NavigationActions): State {
  switch (action.type) {
    case NavigationActionTypes.LoadSuccess: {
      return {
        ...state,
        nodes: action.payload 
      };
    }
    default: {
      return state;
    }
  }
}

export const getNavigationNodes = (state: State) => state.nodes;



// WEBPACK FOOTER //
// ./src/app/core/store/reducers/navigation.reducer.ts